__turbopack_context__.v({
  "agentAvatar": "styles-module__n0wyzG__agentAvatar",
  "agentDetails": "styles-module__n0wyzG__agentDetails",
  "agentInfo": "styles-module__n0wyzG__agentInfo",
  "agentMobileInfo": "styles-module__n0wyzG__agentMobileInfo",
  "agentName": "styles-module__n0wyzG__agentName",
  "agentRole": "styles-module__n0wyzG__agentRole",
  "avatarImage": "styles-module__n0wyzG__avatarImage",
  "btnAgency": "styles-module__n0wyzG__btnAgency",
  "btnAgencyWrp": "styles-module__n0wyzG__btnAgencyWrp",
});
